import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { BarChart, LineChart, PieChart } from 'echarts/charts';
import { GridComponent, TooltipComponent, LegendComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { montarOpcoes, alturaDoGrafico } from './opcoesEcharts';
import './styles.scss';

// Registro seletivo, uma vez por modulo: importar 'echarts' inteiro traria o
// pacote completo para o bundle, e o build do CRA nao remove o que nao se usa.
echarts.use([
  BarChart,
  LineChart,
  PieChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  CanvasRenderer
]);

// O ECharts nao redesenha sozinho quando o container muda de tamanho. O balao
// muda de altura conforme o texto chega, entao o resize automatico e
// obrigatorio -- sem ele o grafico nasce com a largura do primeiro layout.
const OPCOES_INSTANCIA = { renderer: 'canvas' };

/**
 * Os graficos que as ferramentas geraram para esta resposta.
 *
 * Os dados vem em `meta.graficos`, montados no backend a partir do resultado
 * real da consulta -- nunca do texto do modelo. Aqui e so desenho: nenhuma
 * decisao sobre o que pode ou nao ser exibido acontece neste componente.
 */
function GraficoResposta({ graficos }) {
  const preparados = useMemo(
    () =>
      (graficos ?? [])
        .filter(grafico => Array.isArray(grafico?.pontos) && grafico.pontos.length > 0)
        .map(grafico => ({
          ...grafico,
          opcoes: montarOpcoes(grafico),
          altura: alturaDoGrafico(grafico)
        })),
    [graficos]
  );

  if (preparados.length === 0) {
    return null;
  }

  return (
    <Box className="chat-ia-graficos">
      {preparados.map((grafico, indice) => (
        <Box className="chat-ia-grafico" key={`${grafico.titulo}-${indice}`}>
          <Typography className="chat-ia-grafico-titulo" variant="caption">
            {grafico.titulo}
          </Typography>

          {grafico.unidade && (
            <Typography className="chat-ia-grafico-unidade" variant="caption">
              {grafico.unidade}
            </Typography>
          )}

          <ReactEChartsCore
            echarts={echarts}
            option={grafico.opcoes}
            style={{ width: '100%', height: grafico.altura }}
            opts={OPCOES_INSTANCIA}
            notMerge
            lazyUpdate
          />
        </Box>
      ))}
    </Box>
  );
}

// Como as bolhas anteriores nao mudam durante o streaming da ultima, o memo
// evita redesenhar um canvas ja pronto a cada delta.
export default React.memo(GraficoResposta);
